module.exports = __webpack_public_path__ + "static/media/chevron_up_blue.8383e05b.svg";